import React, { Component } from 'react';
import { uniqueId } from 'lodash';

import './Letter.css';

export class Letter extends Component {
    static displayName = Letter.name;

    constructor(props) {
        super(props);
    }

    updateLetters() {
        let letterData = {
            letter: null,
            class: null
        }
        let datas = [];

        for (var i = 0; i < this.props.text.length; i++) {
            switch (this.props.text[i]) {
                case '!':
                    letterData.class = 'inPosition';
                    break;
                case '?':
                    letterData.class = 'used';
                    break;
                default:
                    letterData = {
                        letter: this.props.text[i],
                        class: null
                    };
                    datas.push(letterData);
                    break;
            }
        }

        return datas;
    };

    render() {
        return (
            <div className="letter">
                {this.updateLetters()?.map(l =>
                    <span className={l.class} key={uniqueId("letter-")}>{l.letter}</span>
                )}
            </div>
        );
    }
}